import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Drawer from '@mui/material/Drawer';
import { Theme } from '@/shared/theme';
import { BorisScreener } from '@/shared/borisScreenerTheme';
import CloseIcon from '@/assets/images/close-cross.svg';

const IFRAME_MARGIN = 78;

const Wrapper = styled.div`
  background-color: ${BorisScreener.coral};
  overflow: hidden;
`;

const CloseButton = styled.button`
  position: absolute;
  top: ${Theme.Spacing.x1}px;
  right: ${Theme.Spacing.x1}px;
  background: ${BorisScreener.coral};
  border: none;
  cursor: pointer;
  z-index: 1;
`;

const ExternalLinkContent = styled.iframe<{ iframeHeight: number }>`
  width: 100%;
  height: ${props => props.iframeHeight}px;
  margin-top: ${Theme.Spacing.x3}px;
  margin-bottom: -4px;
  border: none;
`;

const LinkDrawer: React.FC<{
  url: string;
  title: string;
  isOpen: boolean;
  handleClose: (e: React.MouseEvent | React.KeyboardEvent) => void;
}> = ({ url, title, isOpen, handleClose }) => {
  const [iframeHeight, setIframeHeight] = useState(0);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    if (isOpen && !iframeLoaded) {
      setIframeLoaded(true);
    }
  }, [isOpen, iframeLoaded]);

  useEffect(() => {
    const calculateIframeHeight = () => {
      const screenHeight = window.innerHeight;
      const marginOnTop = Theme.Spacing.x3 + IFRAME_MARGIN;
      const calculatedHeight = screenHeight - marginOnTop;
      setIframeHeight(calculatedHeight);
    };

    calculateIframeHeight();

    window.addEventListener('resize', calculateIframeHeight);

    return () => {
      window.removeEventListener('resize', calculateIframeHeight);
    };
  }, []);

  return (
    <Drawer
      anchor="bottom"
      open={isOpen}
      onClose={handleClose}
      sx={{
        '& .MuiDrawer-paper': {
          borderRadius: '16px 16px 0 0',
          boxShadow: '0px -8px 20px 2px rgba(19, 37, 53, 0.12)',
        },
      }}
    >
      <Wrapper>
        <CloseButton type="button" onClick={handleClose} aria-label="Close">
          <img src={CloseIcon} alt="Close" />
        </CloseButton>
        {iframeLoaded && (
          <ExternalLinkContent src={url} title={title} iframeHeight={iframeHeight} />
        )}
      </Wrapper>
    </Drawer>
  );
};

export default LinkDrawer;
